"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const lipstick = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-lipstick` : '') + (description ? ` desc-lipstick` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-lipstick"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-lipstick"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2074)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.4108 0.363247C20.7662 0.00848028 21.3002 -0.0975362 21.7642 0.0945504C22.2282 0.286637 22.531 0.739077 22.5316 1.24218V6.96325C22.5294 7.42963 22.3432 7.8763 22.0133 8.20673L18.7412 11.4787C19.0988 11.9608 19.059 12.6449 18.6218 13.0821L15.0355 16.6693C15.3948 17.1516 15.3555 17.837 14.9177 18.2748L9.70349 23.489C9.02214 24.1703 7.91746 24.1703 7.23612 23.489L2.01101 18.2639C1.32966 17.5825 1.32966 16.4779 2.01101 15.7965L7.22523 10.5823C7.66213 10.1454 8.34562 10.1054 8.82768 10.4622L12.4156 6.87592C12.8522 6.43932 13.5351 6.39906 14.0171 6.75514L20.4108 0.363247ZM8.09633 11.7425L3.02696 16.8125C2.92174 16.9177 2.90859 17.0801 2.9875 17.1996L3.02696 17.2479L8.25207 22.473C8.37232 22.5933 8.56729 22.5933 8.68754 22.473L13.7572 17.4034L13.527 17.173L13.5202 17.1679L8.32988 11.9776C8.32578 11.9735 8.32174 11.9694 8.31776 11.9652L8.09633 11.7425ZM13.2864 8.03631L9.85385 11.4689L14.028 15.6431L17.4606 12.2105L17.239 11.989L17.2256 11.9773L13.5196 8.27023C13.5174 8.26802 13.5152 8.2658 13.5131 8.26357L13.2864 8.03631ZM21.0949 1.71073L15.0432 7.76241L17.7338 10.452L20.997 7.19106C21.0437 7.14431 21.0752 7.08516 21.0882 7.02282L21.0949 6.95975V1.71073Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2074"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = lipstick;